export const GET_PRODUCT_SUCCESS="GET_PRODUCT_SUCCESS";
export const GET_User_SUCCESS="GET_User_SUCCESS";
export const GET_Video_SUCCESS="GET_Video_SUCCESS";
export const ADD_PRODUCT_SUCCESS="ADD_PRODUCT_SUCCESS";
export const ADD_User_SUCCESS="ADD_User_SUCCESS";
export const ADD_Video_SUCCESS="ADD_Video_SUCCESS";
export const DELETE_PRODUCT_SUCCESS="DELETE_PRODUCT_SUCCESS";
export const DELETE_User_SUCCESS="DELETE_User_SUCCESS";
export const DELETE_Video_SUCCESS="DELETE_Video_SUCCESS";
export const PATCH_PRODUCT_SUCCESS="PATCH_PRODUCT_SUCCESS";
export const PATCH_User_SUCCESS="PATCH_User_SUCCESS";
export const PATCH_Video_SUCCESS="PATCH_Video_SUCCESS";



export const PRODUCT_REQUEST="PRODUCT_REQUEST";
export const PRODUCT_FAILURE="PRODUCT_FAILURE";
